// import { getAuthFromLocalStorage } from './persistAuthToken'

export const API_BASE_URL = `${process.env.API_CONTACTS_URL}/api/${process.env.API_CONTACTS_VERSION}`

// export const API_REQUEST_OPTIONS = {
//   headers: {
//     'Content-Type': 'application/json',
//     Authorization: getAuthFromLocalStorage() || '',
//   },
// }

export const endpoints = {
  acceptInvitation: 'invitation/accept', // GET
  completeInvitation: 'invitation', // PUT
  login: 'login', // POST
  logout: 'logout', // DELETE
  me: 'user/me', // GET
  editProfile: 'user/update', // PUT
  locations: 'locations', // GET
  uploadFile: 'user/upload', // POST
  registryPdf: 'user/registry', // GET
  forgotPassword: 'password/forgot', // POST
  resetPassword: 'password/reset', // POST
  quotationsIndex: 'user/quotation_requests', // GET
  quotationDetail: 'user/quotation_requests', // GET user/quotation_requests/:id
  uploadQuotation: 'user/quotation_requests', // POST user/quotation_requests/:id
  sendReminderEmail: 'user/registration_reminder', // GET
  sendQuotationChatMessage: (quotationRequestId: number) =>
    `user/quotation_requests/${quotationRequestId}/create_message`, // GET user/quotation_requests/:id/create_message
}
